import styled from 'styled-components';

const HomeArticle1 = () => {
  return (
    <Container>
        <Header>
            <Title>Empresa de Construção em Santos, Reformas, Manutenção e Reparos</Title>
            <BottomLine></BottomLine>
        </Header>

        <TextWrapper>
            <Text>
            Administradora de obras que atua com construções e reformas de imóveis residenciais e comerciais.
            <br />
            <br />
            Está precisando construir sua casa ou reformar seu apartamento, e não quer se preocupar com custos excessivos de desperdícios e retrabalhos, mão de obra despreparada, serviços sem garantia e falta de tempo para solucionar os problemas de sua obra? <br />
            <b>Precisa de reparos em sua casa ou manutenção predial e de condomínio? </b> <br />
            Esse é o motivo pelo qual a Remold Serviços. existe e pode lhe ajudar. Foque no que você faz de melhor e deixe o resto com a gente.
            <br />
            <br />
            O relacionamento com fornecedores (pedreiro, encanador, pintor, eletricista, marceneiro, ou qualquer outra mão de obra), é uma tarefa difícil e estressante. Nós da Remold Serviços Construções nos responsabilizamos por 100% disso para você, e tudo isso com a praticidade de resolver tudo em um só lugar. Agora ficou mais fácil e rápido manter, reparar e solucionar problemas no seu imóvel, sem a preocupação de ter que encontrar um tempinho na correria do dia-dia.
            <br />
            <br />
            Garantimos a melhor prestação de serviço na área de construção civil e reforma de imóveis, aliando qualidade e excelência em toda abrangência de atuação.
            </Text>
        </TextWrapper>
    </Container>
  )
}

const Container = styled.article`
    padding: 50px;
    padding: 50px 20px;

    @media (min-width: 780px) {
        padding: 50px 50px;
    }
`;

const Header = styled.header`
    margin-bottom: 25px;
`;

const Title = styled.h2`
    color: #494544;
    font-size: 2rem;
    font-weight: 400;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const BottomLine = styled.div`
    background-color: #f2c70f;
    height: 3px;
    width: 50px;
    margin-top: 10px;
    border-radius: 35px;
`;

const TextWrapper = styled.div`
    padding: 20px;
    border: 1px solid #33333334;
    border-radius: 5px;
    border-left: 5px solid #f2c70f;
`;

const Text = styled.p`
    color: #5b5b5b;
    font-size: 1rem;
    line-height: 1.8rem;
`;

export default HomeArticle1